export const WEB_PROGRESO = window.WEB_PROGRESO;
export const BASE = window.API_URL;
export const BASEMOCK = "https://2c5c005e-4909-4195-8f9a-6ae824418547.mock.pstmn.io";
export const servipag = "/servipag";
export const WebPagos = "/api/v1/WebPagos";
export const PORTAL = "/Portal";
export const LEASING = "/api/v1/Leasing";

export const APIINTEGRACION = {
    GET : {
        CONTRATOS : `${BASE}${WebPagos}/obtenerContratos/`,
        CUOTAS: `${BASE}${WebPagos}/cuotas/{nroperacion}/{rut}/{tipo}`,
        EXPORTAR_CRONOGRAMA: `${BASE}${WebPagos}/exportarCronograma/{rut}/{nroperacion}/{tipo}`,
        ERROR:  `${BASEMOCK}/error`,
    },
    POST : {
        REDIRECT : `${BASE}${WebPagos}/redireccionWebPagos/`,
        REFRESH_TOKEN : `${BASE}${WebPagos}/refreskToken/`,
        ENVIARXML1 : `${BASE}${WebPagos}/generarXML1`,
        PREXML1 : `${BASE}${WebPagos}/preXML1`,
        IRPAGAR :  `${BASE}${WebPagos}/irPagar`,
        CAMBIO_CONTEXTO : `${BASE}${servipag}/cambio_contexto`,
        H2H : `${BASE}${servipag}/notificacion_pago`
    }
}
export const PORTALSAPI = {
    POST: {
        OBTENERURLFACTURA: `${BASE}${LEASING}/obtenerDocPaperLess`
    }
  
}
export const APIMOCKSERVER= {
    GET : {
        ERROR:  `${BASEMOCK}/error`
    }
}